"use client"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import Navbar from "../../../../components/navbar"
import Footer from "../../../../components/footer"
import Table from "../../../../components/Table"
import styles from "../css/clinicHistory.module.css"
import { fetchScriptDetails } from "../../../../api/dispensary/script/processScriptApi"

export default function ClinicHistory({ 
  showNotes = true, 
  pageTitle = 'Clinic History',
  sectionTitle = 'Medication Prescribed'
}) {
  const location = useLocation()
  const { scriptData: navScriptData } = location.state || {}
  const [loadedData, setLoadedData] = useState(null)
  const baseData = navScriptData || {}
  const scriptData = loadedData || baseData || {}

  useEffect(() => {
    const firstNumeric = (val) => {
      if (val == null) return null
      const n = Number(val)
      return Number.isFinite(n) ? n : null
    }
    const idNumeric = firstNumeric(baseData?.id)
      ?? firstNumeric(baseData?.scriptId)
      ?? firstNumeric(baseData?.scriptNo)
      ?? firstNumeric(baseData?.scriptNumber)
    if (!idNumeric) return
    let alive = true
    ;(async () => {
      try {
        const data = await fetchScriptDetails(String(idNumeric))
        if (!alive || !data) return
        const pharmacist = data.pharmacist
          ? `${data.pharmacist.firstname || ''} ${data.pharmacist.surname || ''}`.trim()
          : ''
        const practitioner = data.practitioner
          ? `${data.practitioner.title ? data.practitioner.title + ' ' : ''}${data.practitioner.firstname || ''} ${data.practitioner.surname || ''}`.trim()
          : ''
        setLoadedData({
          scriptNumber: String(baseData?.scriptNumber || data.script?.id || idNumeric),
          date: data.script?.date || baseData?.date || '',
          paymentType: data.script?.paymentType || baseData?.paymentType || '',
          practitioner,
          pharmacist,
          drugs: Array.isArray(data.drugs) ? data.drugs : [],
        })
      } catch (e) {
        console.error('Failed to fetch clinic script details', e)
      }
    })()
    return () => { alive = false }
  }, [baseData?.scriptNumber, baseData?.scriptNo, baseData?.scriptId, baseData?.id])

  const scriptInfo = [
    { label: 'Script Number', value: scriptData?.scriptNumber || '' },
    { label: 'Date', value: scriptData?.date || '' },
    { label: 'Payment Type', value: scriptData?.paymentType || '' },
    { label: 'Practitioner', value: scriptData?.practitioner || '' },
    { label: 'Pharmacist', value: scriptData?.pharmacist || '' },
  ]
  const scriptColumns = [
    { header: 'Description', accessor: 'label' },
    { header: 'Value', accessor: 'value' },
  ]

  const columns = [
    { header: 'Drug Name', accessor: 'drugName' },
    { header: 'Quantity', accessor: 'quantity' },
    { header: 'Instructions', accessor: 'instructions' },
    { header: 'Pack Size', accessor: 'packSize' },
    { header: 'Strength', accessor: 'strength' },
    { header: 'ICD-10', accessor: 'icd10' },
    { header: 'Nappi Code', accessor: 'nappiCode' },
    { header: 'Cost Price', accessor: 'costPrice' },
  ]

  const medicationData = Array.isArray(scriptData?.drugs) ? scriptData.drugs : []

  return (
    <div className={styles.app}>
      <div className={styles.mainContainer}>
        <Navbar />

        <main className={styles.content}>
          <div className={styles.pageHeader}>
            <h2 className={styles.pageTitle}>{pageTitle}</h2>
          </div>

          <div className={styles.tablesContainer}>
            <div className={styles.scriptTableSection}>
              <h3 className={styles.sectionTitle}>Script Information</h3>
              <Table columns={scriptColumns} data={scriptInfo} />
            </div>

            <div className={styles.medicationTableSection}>
               <h3 className={styles.sectionTitle2}>{sectionTitle}</h3>
              <Table columns={columns} data={medicationData} />
            </div>
          </div>

          {showNotes && (
            <div className={styles.notesSection}>
              <h3 className={styles.notesTitle}>Additional Notes</h3>
              <p className={styles.notesText}>Clinic visit notes.</p>
            </div>
          )}

        </main>

        <div className={styles.footerWrapper}>
          <Footer />
        </div>
      </div>
    </div>
  )
}
